import Vue from 'vue';
import axios from 'axios';

import App from './App';
import router from './router';
import store from './store';

import BootstrapVue from 'bootstrap-vue';
import BookBlock from '@/assets/js/vue-bookblock/vue-bookblock';
import VueGtag from 'vue-gtag';
import VueSignaturePad from 'vue-signature-pad';
import VueImpress from 'vue-impress';
import 'vue-impress/dist/vue-impress.css';
import vueVimeoPlayer from 'vue-vimeo-player';
Vue.use(vueVimeoPlayer);
Vue.use(VueImpress);

var jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';
Vue.use(VueKatex, {
  // globalOptions: {
  //   //... Define globally applied KaTeX options here
  // },
});
import PouchDB from 'pouchdb-browser';
// import { fetchAllVideo, fetchAllAudio } from '__mainSrcDir/Utils/DB/fetchAll';
// if (process.env.VUE_PWA) {
//   fetchAllVideo();
//   fetchAllAudio();
// }

import '@/assets/js/vue-bookblock/styles/bookblock.css';
import 'animate.css/animate.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Keycloak from 'keycloak-js';
import VueDragResize from 'vue-drag-resize';
// const fs = require('fs-extra');
// const path = require('path');

console.log('process.env.IS_WEB', process.env.IS_WEB);
console.log('process.env.VUE_APP_IS_WEB', process.env.VUE_APP_IS_WEB);
// if (!process.env.IS_WEB || !process.env.VUE_APP_IS_WEB || process.env.NODE_ENV != 'development') {
//   // Async with promises:
//   fs.copy(
//     path.join(__dirname, `../../../../static/${process.env.MULTIBOOK_TYPE}/filesBackup/`),
//     path.join(__dirname, `../../../../static/${process.env.MULTIBOOK_TYPE}/files/`)
//   )
//     .then(() => console.log('success!'))
//     .catch((err) => console.error(err));
// }
Vue.component('vue-drag-resize', VueDragResize);
Vue.use(
  VueGtag,
  {
    config: { id: 'G-73L7Q2WD16' },
    appName: 'Edukacja Informatyczna kl.1',
    pageTrackerScreenviewEnabled: true,
  },
  router
);
// if (!process.env.IS_WEB || !process.env.VUE_APP_IS_WEB) {
//   Vue.use(require('vue-electron'));
// }
Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;

/** instance of PouchDB available from anywhere */
// Vue.pouchDB = Vue.prototype.$pouchDB = () => {
//   return new PouchDB('myDatabase');
// };

Vue.use(VueSignaturePad);
Vue.use(BookBlock);
Vue.use(BootstrapVue);

Vue.config.devtools = process.env.NODE_ENV === 'development';

new Vue({
  components: { App },
  router,
  store,
  template: '<App/>',
}).$mount('#app');
